import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import logo from "../assets/images/logoFederfarma.png"
import Footer from "../components/common/footer";
import { deleteUser } from "../redux/reducer/LoginReducer";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { isLoggedUser } from "../services/Auth";

const SAMLLogin = () => {
  const { t } = useTranslation();
  const dispacth = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((store: any) => store.login);

  const [searchParams] = useSearchParams();
  // const userParam = searchParams.get("user");
  const logoutParam = searchParams.get("logout");

  useEffect(() => {
    const loginUrl = `${process.env.REACT_APP_API}/saml2/federfarma/acs`;

    if (logoutParam) {
      dispacth(deleteUser());

      // wait to save to localStorage before redirect again to login
      // TODO constant also present in src/index.tsx, centralize it!!
      const waitingTime = Number(process.env.REACT_APP_WAITING_TIME) || 800;
      setTimeout(() => {
        window.location.href = loginUrl;
      }, waitingTime + 300);

    } else if (isLoggedUser(user)) {
      console.log('is logged, move to /login')
      // if already logged go to /login where /checknavigation will redirect to initial page
      navigate('/login');

      /**
       * Probably no more used because of new rebounce to be as CORS friendly as possible
       * New process:
       * 1. SAML login React page
       * 2. IdP login on third party portal
       * 3. callback on our server, generate token and redirect to /login with token
       * 4. /login found token in URL and proceed automatically with the login
       */
      // if (userParam) {
      //   const jsonString = Buffer.from(userParam, 'base64').toString();
      //   const user = JSON.parse(jsonString);
      //   dispacth(updateUser(user));
      //   dispacth(updateSaml(user.saml));

      //   HttpService.get(`${process.env.REACT_APP_API}/t4event/api/v01/event/checknavigation`).then(result => {
      //     dispacth(updateEventId(result.data.eventId));
      //     dispacth(updateNamePharmacy(result.data.namePharmacy));
      //     navigate(result.data.navigation);
      //   });

    } else {
      // default action, redirect to login
      window.location.href = loginUrl;
    }
  }, []);

  return (
    <>
      <div className="container">
        <div className="TableCenter h-100 ">
          <div className="Center">
            <div className="col-md-6 col-lg-3 pl-0 pr-0 mx-auto pt-4">
              <div className="text-center">
                <img src={logo} className="mb-4 " alt="Logo" />
              </div>
              <div className="text-center">
                {t('login.saml-loading')}
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SAMLLogin;
